import { render, staticRenderFns } from "./customDetail.vue?vue&type=template&id=1dfcf572&scoped=true&"
import script from "./customDetail.vue?vue&type=script&lang=js&"
export * from "./customDetail.vue?vue&type=script&lang=js&"
import style0 from "./customDetail.vue?vue&type=style&index=0&id=1dfcf572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcf572",
  null
  
)

export default component.exports